export function formatAmount (amount) {
  if (!amount) return 0
  const str = typeof amount === 'string' ? amount : amount.toString()
  const arr = str.split('')
  const l = arr.length - 1
  let result = ''
  for (let i = l; i > -1; i--) {
    if ((l - i + 1) % 3 === 1 && i !== l) {
      result = arr[i] + ',' + result
    } else {
      result = arr[i] + result
    }
  }
  return result
}
